import {
    NgModule,
    Component,
    Input,
    ElementRef,
    OnInit
} from '@angular/core';
import qrcode from 'qrcode-generator';

@Component({
    selector: 'qr-code',
    template: ''
})
export class QRCodeComponent implements OnInit {

    @Input() data = '';
    @Input() size = 128;
    @Input() type:TypeNumber = 4;
    @Input() level :ErrorCorrectionLevel= 'M';

    private qr: QRCode;

    constructor(
        private elementRef: ElementRef
    ) {}

    ngOnInit() {
        try {
            this.qr = qrcode(this.type, this.level);
            this.qr.addData(this.data);
            this.qr.make();

            const imgTagString = this.qr.createImgTag(this.type, 0);
            const el: HTMLElement = this.elementRef.nativeElement;
            el.innerHTML = imgTagString;
            const imgTagObject: HTMLImageElement = <HTMLImageElement> el.firstElementChild;
            imgTagObject.width = this.size;
            imgTagObject.height = this.size;
        } catch (e) {
            console.error(`Could not generate QR Code: ${e.message}`);
        }
    }
}

@NgModule({
    exports: [ QRCodeComponent ],
    declarations: [ QRCodeComponent ],
    entryComponents: [ QRCodeComponent ]
})
export class QRCodeModule { }



// WEBPACK FOOTER //
// ./src/providers/angular2-qrcode/angular2-qrcode.ts